import { render, staticRenderFns } from "./ObjectDataChange.vue?vue&type=template&id=13ff3e9c&scoped=true&"
import script from "./ObjectDataChange.vue?vue&type=script&lang=js&"
export * from "./ObjectDataChange.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDataChange.vue?vue&type=style&index=0&id=13ff3e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff3e9c",
  null
  
)

export default component.exports